import { USER_TYPES } from "../config/constants";

export function isEmptyOrNull(value: any) {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'string') {
    return value.trim() === "";
  }
  return value == null || value === undefined;
}

export function isEmptyArray(array: Array<any> | undefined | null) {
  return array === undefined || array === null || array.length === 0;
}

export function isObjectEmptyOrNull(obj: any) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}

export const capitalizeFirstLetter = (nameString: any) => {
  if (nameString !== undefined && nameString !== "") {
    return nameString.charAt(0).toUpperCase() + nameString.slice(1).toLowerCase();
  }
  return "";
};

export const isArrayValid = (arr: any) => arr !== undefined && Array.isArray(arr) && arr.length > 0;

export const objectContainsKey = (object: any, keyName: string): boolean => {
  if (object === null || typeof object === 'undefined') {
    return false;
  }
  return object?.hasOwnProperty(keyName);
};

export const isUndefined = (target: any): boolean => target === undefined;

export const isAString = (candidate: any) => typeof candidate === "string" || candidate instanceof String;

export const isNull = (target: any): boolean => target === null || target === "";

export const isNonEmptyArray = (target: any[]): boolean => !!target && target.length > 0;

export const countObjectProperties = (target: object) => Object.keys(target).length;

export const isNonEmptyObject = (target: any): boolean => !isEmptyOrNull(target) && countObjectProperties(target) > 0;

export function isEmptyOrZero(value: any) {
  return value === undefined || value === null || (typeof value === "string" ? value.trim() : value) === "" || value === 0 || value.toString() === "0";
}

export const isArray = (arr: any) => arr !== undefined && Array.isArray(arr);

export const arraysAreEqual = (arr1: string[], arr2: string[]): boolean => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};

export function isUserReadOnly(userInfo: any) {
  return userInfo?.userProfile?.role === USER_TYPES.READONLY_USER
}

export const getDayFromSlot = (slot_day_data: any) => {
  let day_name = "Day";
  if (isArrayValid(slot_day_data?.days)) {
    return slot_day_data.days?.[0] ?? day_name;
  } else if (!isEmptyOrNull(slot_day_data) && isAString(slot_day_data)) {
    return slot_day_data;
  }
  return day_name;
};